import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Browse Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Explore our organized product categories to find exactly what you are looking for on Sugargoo Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 hover:bg-background-200 rounded-xl border border-background-200/60 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.imageSrc}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex items-center gap-2 px-4 py-3">
                <span className="w-5 h-5 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap group-hover:text-foreground-950 transition-colors duration-200">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}